//types
import {StoreType} from '..';
import {IOrganization, ITeam} from '../../utils/types';

export const getOrganizationSelector = (state: StoreType): IOrganization | null => state.organizationStore.organization;

export const getOrganizationIdSelector = (state: StoreType): number | undefined =>
	state.organizationStore.organization?.id;

export const getOrganizationIsLoadingSelector = (state: StoreType): boolean => state.organizationStore.isLoading;

export const getTeamSelector = (state: StoreType): ITeam | null => state.organizationStore.team;

export const getTeamOrganizationIdSelector = (state: StoreType): number | undefined =>
	state.organizationStore.team?.organizationId;
